import type { BannerItem } from "$root/components/banner-stack/types";
import type { TFunction } from "i18next";
import type { QuantityEditorBuilderProps } from "../builder";
import { isHeldBlocked } from "./heldIssue";

/**
 * Holdings that can no longer be traded, so their quantities are locked: the save keeps them as
 * they came in. Soft-deleted rows do not count — they leave the composition at save.
 */
export function heldBlockedBanner({
	instrumentBuilder,
	t,
}: {
	instrumentBuilder: Pick<QuantityEditorBuilderProps, "getComposition">;
	t: TFunction;
}): BannerItem | null {
	let count = 0;
	for (const row of instrumentBuilder.getComposition({ removeDeleted: true }).values()) {
		if (isHeldBlocked(row) && !row.deleted) {
			count += 1;
		}
	}
	if (count === 0) {
		return null;
	}
	return {
		id: "held-blocked-rows",
		severity: "warning",
		title: t("EDIT_COMPOSITION.HELD_BLOCKED.TITLE"),
		description: (
			<span data-qualifier="CompositionEditor/HeldBlockedRowsBanner">
				{t("EDIT_COMPOSITION.HELD_BLOCKED.BODY", { count })}
			</span>
		),
	};
}
